import Login from '@/views/login/Login';
import IndexLogin from '@/views/login/index';
import router from '@/routers';

export default [
  {
    path: '/',
    name: 'index-login',
    component: IndexLogin,
    redirect: '/login',
    children: [
      {
        path: '/login',
        name: 'login',
        component: Login,
        beforeEnter: (to, from, next) => {
          if (!localStorage.getItem('token')) {
            next();
          } else {
            router.replace('/home');
          }
        }
      },
      {
        path: '/logout',
        beforeEnter: () => {
          localStorage.clear();
          router.replace('/login');
        }
      }
    ]
  }
];
